import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";
import Sidebar from "../components/Sidebar";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [bookingsCount, setBookingsCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (!storedUser) {
      navigate("/login");
      return;
    }

    const userData = JSON.parse(storedUser);
    setProfile(userData);
  }, [navigate]);

  // ⭐ Fetch booking count of logged-in user
  useEffect(() => {
    if (!profile) return;

    fetch("https://online.funforay.com/admin/api/user-bookings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user_id: profile.id
      })
    })
      .then((res) => res.json())
      .then((data) => {
        setBookingsCount(data.data?.length || 0);
      })
      .catch((err) => console.log("Error fetching bookings:", err));
  }, [profile]);

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <Sidebar />

      <div className="auth-page profiledesign">
        <div className="auth-card">
          <h2>Profile</h2>

          {profile ? (
            <>
              <p>
                <b>Name:</b> {profile.name}
              </p>
              <p>
                <b>Email:</b> {profile.email}
              </p>
            </>
          ) : (
            <p>Loading...</p>
          )}
        </div>

        {/* ⭐ Booking Summary Cards */}
        <div className="bkcardmain">
          {/* Holiday Booking Card */}
         <div className="bkcard">
            <h4>Package Bookings</h4>
            <a href="/booking"> <p style={{ fontSize: "26px", fontWeight: "bold" }}>{bookingsCount}</p> </a>
          </div>
         

          {/* Flight Booking Card (same count unless you have separate API) */}
          <div className="bkcard" style={{ display: "none" }}>
            <h4>Flight Bookings</h4>
            <p style={{ fontSize: "26px", fontWeight: "bold" }}>0</p>
          </div>

          {/* Hotel Booking Card (same for now) */}
          <div className="bkcard" style={{ display: "none" }}>
            <h4>Hotel Bookings</h4>
            <p style={{ fontSize: "26px", fontWeight: "bold" }}>0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
